<script lang="ts">
  import Meta from "$lib/components/meta/MetaMemberProfile.svelte";
  import BackupMeta from "$lib/components/meta/Meta.svelte";
  import type { Contributions } from "$types";
  import "$lib/styles/sorter.css";
  import Gallery from "$lib/components/episodes/ContributionGallery.svelte";

  export let data;

  let filter_active: 0 | 1 = data.bonus ? 1 : 0;
  let asc: boolean = false;

  let gallery: Contributions[] = data.contributions;
  const main_contributions = () => {
    filter_active = 0;
    if (asc) {
      gallery = data.contributions.reverse();
    } else {
      gallery = data.contributions;
    }
  };
  const bonus_contributions = () => {
    filter_active = 1;
    if (asc) {
      gallery = data.bonus_contributions.reverse();
    } else {
      gallery = data.bonus_contributions;
    }
  };
  const reverse_order = () => {
    asc = !asc;
    gallery = gallery.reverse();
  };
</script>

{#if data.contributions.length >= 4}
  <Meta
    title={data.member.profile.display_name}
    description="Contributions, process videos, and curated galleries by {data
      .member.profile.display_name}."
    handle={data.member.handle}
    id={data.member.id}
    name={data.member.profile.display_name}
  />
{:else}
  <BackupMeta
    title={data.member.profile.display_name}
    description="Contributions, process videos, and curated galleries by {data
      .member.profile.display_name}."
    path="/community/{data.member.handle}"
  />
{/if}

{#if data.contributions.length > 1 || data.bonus_contributions.length > 1}
  <div class="sorter">
    <div>
      <button class:active={filter_active === 0} on:click={main_contributions}>
        Main Contributions
        {#if data.contribution_count > 0}
          <span>{data.contribution_count}</span>
        {/if}
      </button>
      {#if data.bonus_contributions.length > 0}
        <button
          class:active={filter_active === 1}
          on:click={bonus_contributions}
        >
          Bonus Contributions

          <span>{data.bonus_contributions.length}</span>
        </button>
      {/if}
    </div>
    {#if gallery.length > 1}
      <button id="order" on:click={reverse_order}>
        <svg
          class:asc
          fill="none"
          viewBox="0 0 24 24"
          height="24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            xmlns="http://www.w3.org/2000/svg"
            d="M12 4C12.5523 4 13 4.44772 13 5V16.5858L17.2929 12.2929C17.6834 11.9024 18.3166 11.9024 18.7071 12.2929C19.0976 12.6834 19.0976 13.3166 18.7071 13.7071L12.7071 19.7071C12.3166 20.0976 11.6834 20.0976 11.2929 19.7071L5.29289 13.7071C4.90237 13.3166 4.90237 12.6834 5.29289 12.2929C5.68342 11.9024 6.31658 11.9024 6.70711 12.2929L11 16.5858V5C11 4.44772 11.4477 4 12 4Z"
            fill="#0D0D0D"
          />
        </svg>
      </button>
    {/if}
  </div>
{/if}

{#if gallery.length > 0 && filter_active === 0}
  {#key gallery}
    <Gallery
      {gallery}
      base="/community/{data.member.handle}"
      context="community"
    />
  {/key}
{:else if gallery.length > 0 && filter_active === 1}
  {#key gallery}
    <Gallery
      {gallery}
      base="/community/{data.member.handle}"
      context="community-bonus"
    />
  {/key}
{:else if filter_active === 0 && !gallery.length}
  <div class="no_results">
    <p>No contributions found.</p>
    {#if data.is_me}
      <p>
        If you have previously contributed, check out the <a
          href="/members/contributions/claim">claim page</a
        > to see if you have any unclaimed contributions.
      </p>
    {/if}
  </div>
{:else}
  <div class="no_results">
    <p>No bonus contributions found.</p>
    {#if data.is_me}
      <p>
        You can start now by contributing to a past episode or bonus challenge.
        If you have made bonus contributions in the past and they are not
        showing up here, please get in touch with us.
      </p>
    {/if}
  </div>
{/if}

<style>
  .no_results {
    background: white;
    border-radius: 1rem;
    padding: 2rem;
    box-shadow: var(--shadow);
    line-height: 1.5;
  }

  .asc {
    transform: rotate(180deg);
  }
</style>
